"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dueDateDisplayFormats = void 0;
exports.dueDateDisplayFormats = ["compact", "standard", "long"];
